import Vue from 'vue'
import convert from 'xml-js'

import store from '../store';

export default class APIService {

  url = ''

  constructor(url) {
    if (url) {
      this.setUrl(url)
    }
  }

  setUrl(url) {
    this.url = url
  }

  user() {
    return store.getters.user
  }


  /**
   *
   * @param {String} name Name of Folder
   * @param {Number} type Type of Folder, 1: search, 2: mailing
   * @param {Number} parent_id ID of Parent Folder, optional
   */
  createFolder(name, type, parent_id=null) {
    return this._call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Folder',
      '_method': 'create',
      'oid': this.user().oid,
      'name': name,
      'type': type, // 1: search, 2: mailing
      'parent_id': parent_id
    })
  }

  updateFolder(name, parent_id=null) {
    return this._call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Folder',
      '_method': 'update',
      'oid': this.user().oid,
      'name': name,
      parent_id: parent_id
    })
  }

  // NOTE: check containing Searches if inUse
  deleteFolder(id) {
    return this._call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Folder',
      '_method': 'delete',
      'oid': this.user().oid,
      'id': id,
      'force': true
    })
  }

  loadDashboardWidget_DispatchMailings() {
    return this._call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Mailing',
      '_method': 'list_sending_mailings',
      'oid': this.user().oid
    })
  }

  loadDashboardWidget_Statistics() {
    return this._call(this.url, {
      '_ticket': this.user().ticket,
      '_class': 'Statistics',
      '_method': 'grouped_count',
      'oid': this.user().oid,
      'xml': `<request>
  <report>
    <group_by>
      <field id="country"/>
    </group_by>
    <where>
      <search_block>
        <search id="country" type="field" operator="equals">
          <value>AF</value>
          ...
          <value>ET</value>
        </search>
      </search_block>
    </where>
  </report>
</request>`
    })
  }

  // -------------------

  call_init(data) {
    store.commit('incInit')
    return this.call_oid(data)
  }

  call_busy(data) {
    store.commit('incBusy')
    return this.call_oid(data)
      .then(response => {
        store.commit('decBusy')
        return response
      }, error => {
        store.commit('decBusy')
        if((error.text.indexOf('TICKET') >=0) && (error.text.indexOf('INVALID') >=0)) {
          //
        } else {
          store.commit('showMessage', {content: error.text, color: 'red'})
        }
        return error
      })
  }

  call_oid(data) {
    data._ticket = this.user().ticket
    data.oid = this.user().oid
    return this._call(data)
  }

  _call(url, data = null) {
    if (!data) {
      data = url
      url = this.url
    }
    return new Promise((resolve, reject) => {
      var form_data = new FormData()
      data.nocache = new Date().getTime()
      for (let i in data) {
        if (Array.isArray(data[i]) && data[i].length > 1) {
          for (let j in data[i]) {
            form_data.append(i, data[i][j])
          }
        } else {
          form_data.append(i, data[i])
        }
      }
      // delete Vue.axios.defaults.headers.common['Accept']
      Vue.axios.post(url, form_data, {dataType:'xml'})
        .then(response => {
// console.log('response', response)
          try {
            response = JSON.parse(convert.xml2json(response.data, {compact: true})).response
            if (response._attributes.status === 'ok') {
              resolve(response)
            } else {
              if (response._attributes.status === 'session-expired') {
                store.dispatch('logout')
              } else if (response._attributes.status === 'error') {
                console.log('API.Error: ', response)
                // TODO: handle code "OBJECT_NOT_FOUND" error -- "Missing object" : "This object could not be loaded. Probably it has been deleted in the meantime."
              }
              reject({ status: response._attributes.status, code: response._attributes.code, text: response._text || null, reason: response.reason ? response.reason._text : response._text || null })
            }
          } catch (e) {
            reject({ text: response.data })
          }
        })
        .catch(reason => {
// console.log('reason', reason)
          console.error(reason)
          store.dispatch('flagNetworkError')
          store.dispatch('clearIsBusy')
          reject(reason)
        })
    })
  }

  simple_post(params) {

    params._ticket = this.user().ticket
    params.oid = this.user().oid

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.url
  
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
  
        form.appendChild(hiddenField);
      }
    }
  
    document.body.appendChild(form);
    form.submit();
    form.remove();
  }

  buildXml(jsonObject) {
    return convert.json2xml(jsonObject, {compact: true})
  }
}
